import React, {useState, useEffect} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateFilter = ({
  initialStartDate,
  initialEndDate,
  onCustomDateRangeChange,
}) => {
  const [startDate, setStartDate] = useState(
    initialStartDate ? new Date(initialStartDate) : null,
  );
  const [endDate, setEndDate] = useState(
    initialEndDate ? new Date(initialEndDate) : null,
  );

  useEffect(() => {
    setStartDate(initialStartDate ? new Date(initialStartDate) : null);
    setEndDate(initialEndDate ? new Date(initialEndDate) : null);
  }, [initialStartDate, initialEndDate]);

  const handleStartDateChange = date => {
    setStartDate(date);
    if (date && endDate && date > endDate) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = date => {
    setEndDate(date);
  };

  const handleApply = () => {
    if (startDate && endDate) {
      onCustomDateRangeChange(startDate, endDate, true);
    }
  };

  return (
    <div className="flex flex-col gap-2 border-t border-t-grey5 pt-3 px-2 -mt-1 w-full">
      <div className="flex items-center gap-2 w-full">
        <div className="flex flex-col items-start lookup-filter w-full">
          <label className="uppercase text-xs text-body font-medium mb-[5px]">
            From
          </label>
          <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={new Date()}
            placeholderText="Start date"
            dateFormat="MM/dd/yyyy"
            className="w-full p-2 border border-[#BFD3F3] rounded text-sm"
          />
        </div>
        <div className="flex flex-col items-start lookup-filter w-full">
          <label className="uppercase text-xs text-body font-medium mb-[5px]">
            To
          </label>
          <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={new Date()}
            placeholderText="End date"
            dateFormat="MM/dd/yyyy"
            className="w-full p-2 border border-[#BFD3F3] rounded text-sm"
          />
        </div>
      </div>
      <button
        className="w-full h-[34px] bg-brandBlue text-sm text-white px-2 rounded mt-2 flex items-center justify-center"
        onClick={handleApply}
        disabled={!startDate || !endDate}
      >
        Apply
      </button>
    </div>
  );
};

export default DateFilter;
